import ProductPageLayout, { ProductPageConfig } from "@/components/products/ProductPageLayout";
import pastaBox500 from "@/assets/products/pasta-box-500ml.png";
import pastaBox750 from "@/assets/products/pasta-box-750ml.png";
import pastaBox1000 from "@/assets/products/pasta-box-1000ml.png";

const config: ProductPageConfig = {
  name: "Pasta Box en carton kraft",
  breadcrumbName: "Pasta Box",
  subtitle: "Boîtes kraft pour pâtes, nouilles, riz et plats à emporter",
  features: ["Contact alimentaire", "Recyclable", "Résistant à la chaleur", "FSC certifié", "Disponible en stock"],
  variants: [
    { capacity: "500 ml", material: "Carton kraft", packaging: "Carton de 500 (10 x 50)", palette: "24 cartons", image: pastaBox500 },
    { capacity: "750 ml", material: "Carton kraft", packaging: "Carton de 300 (10 x 50)", palette: "17 cartons", image: pastaBox750 },
    { capacity: "1 000 ml", material: "Carton kraft", packaging: "Carton de 200 (10 x 50)", palette: "13 cartons", image: pastaBox1000 },
  ],
  customization: { maxColors: 4, minOrder: "20 000 pièces", bestPrice: "100 000 pièces" },
};

const PastaBox = () => <ProductPageLayout config={config} />;
export default PastaBox;
